import { useAtomValue, useSetAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { DatepickerPeriodsAvailableType } from '@/lib/periods';
// Lib
import { periodsTranslation } from '@/lib/periods';

import type { DatepickerRangeAtomImmer } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
// Atoms
import { datepickerAtom } from '@/components/base/Datepicker/DatepickerComponent/Atoms/datepickerAtom';
import {
    getPeriodsInfosAtom,
    updatePeriodAtom
} from '@/components/base/Datepicker/DatepickerComponent/Atoms/periodsAtom';
import Tooltip from '@/components/base/Tooltip';
import { CustomTab } from '@/components/composite/PeriodPicker/components/PeriodTabs/CustomTab';
// Components
import { TabItem } from '@/components/composite/PeriodPicker/components/PeriodTabs/TabItem';

export type PeriodTabsProps = {
    availablePeriods: DatepickerPeriodsAvailableType[];
};

export function PeriodTabs({ availablePeriods }: PeriodTabsProps) {
    const { t } = useTranslation();
    const periodsInfos = useAtomValue(getPeriodsInfosAtom);
    const datepickerData = useAtomValue(datepickerAtom as DatepickerRangeAtomImmer);
    const updatePeriod = useSetAtom(updatePeriodAtom);

    return availablePeriods.map((period) => {
        if (period === 'custom') {
            return <CustomTab key={period} />;
        }

        const isActive = datepickerData.period === period;
        const isDisabled = periodsInfos[period].isDisabled;
        const tooltipContent = isDisabled ? t('commons:datepicker.no_data_period') : null;

        return (
            <Tooltip key={period} position="bottom" content={tooltipContent}>
                <span>
                    <TabItem
                        data-testid={`period-${period}${isActive ? '-active' : ''}`}
                        disabled={isDisabled}
                        isActive={isActive}
                        onClick={() => updatePeriod(period)}>
                        {t(periodsTranslation[period])}
                    </TabItem>
                </span>
            </Tooltip>
        );
    });
}
